<template>
  <div>
    <Topheader></Topheader>
    <div class="w1100">
      <div class="seeinterflow">
        <div class="left">
          <div class="Img" v-if="info.dynamic.type == 3">
            <img
              v-for="(item,index) in info.dynamic.imgList"
              :key="`home`+index"
              :src="item"
              alt=""
              srcset=""
            >
          </div>
          <!--招牌玩家-->
          <div class="Img" v-if="info.dynamic.type == 4">
            <img :src="info.dynamic.signboard.img_url" alt="" srcset="">
          </div>
          <!--博文信息-->
          <div class="Img" v-else-if="info.dynamic.type == 6">
            <img :src="info.dynamic.imgList[0]" alt="" srcset="">
          </div>
          <div class="Img" v-else-if="info.dynamic.type == 2">
            <el-carousel arrow="always" height="600px"   :autoplay="false">
              <el-carousel-item v-for="(item,index) in info.dynamic.imgList" :key="`for2`+index">
                <img :src="item" alt="" srcset="">
              </el-carousel-item>
            </el-carousel>
          </div>
          <!-- 留言 -->
          <div class="word" v-html="info.dynamic.content"></div>
          <div class="word">{{info.dynamic.title}}</div>
          <div class="word">{{info.dynamic.signboard.title}}</div>
          <div class="word">{{info.dynamic.question.question_info}}</div>
          <!--Highlight  -->
          <div class="HeightLight" :class="info.dynamic.content?'active':'active'">
            <div class="nameAll" @click="onHighlight()">
              <span v-if="info.dynamic.is_highlight">
                <img src="../../static/icon/highlighton.png" alt="">
              </span>
              <span v-else>
                <img src="../../static/icon/highlight.png" alt="">
              </span>
              <div class="name">Highlight</div>
            </div>
            <div class="num">{{info.dynamic.highlight_num}}</div>
          </div>
          <!-- 头像 -->
          <div class="headerImgAll">
            <div class="hederImg">
              <img
                style="width: 54px; height: 54px;border-radius: 50%;"
                :src="info.dynamic.head_url"
                alt=""
              >
            </div>
            <div class="nameS">
              <div class="nameWord">{{info.dynamic.user_name}}</div>
              <div class="time">{{info.dynamic.create_time}}</div>
            </div>
          </div>
          <!-- 发布者 -->
          <div class="published">
            <div class="times">Published on {{info.dynamic.create_time}}</div>
            <div class="Massege">
              <div class="msgAll">
                <div class="tits">发布者</div>
                <div class="conts">{{info.dynamic.user_name}}</div>
              </div>
              <div class="msgAll">
                <div class="tits">类型</div>
                <div class="conts">{{info.dynamic.type_text}}</div>
              </div>
              <div class="msgAll">
                <div class="tits">版权标准</div>
                <div class="conts">Woshuoxia图像</div>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div v-if="info.is_huifu ==1">
            <div class="tit">
              <div class="titWord" :class="tabActive==1?'active':''" @click="tab(1)">回复</div>
            </div>
            <!-- textarea -->
            <div class="Textarea" v-if="tabActive==1">
              <div class="div1">
                <div class="div2">
                  <div class="div3">
                    <textarea
                      class="textareaOne"
                      @input="textareaWordL"
                      cols="30"
                      rows="10"
                      :placeholder="placeholder"
                      v-model="textareaWord"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <!-- post -->
            <div class="postAll" v-if="tabActive==1">
              <div class="left"></div>
              <div class="right">
                <div class="postBtn" @click="onSubmit()" :class="textareaLength>0?'active':''">Post</div>
              </div>
            </div>
            <!-- talkMessage

            -->
          </div>
          <div class="talkMessage">
            <div class="div1">
              <div class="div2">
                <div class="div3" ref="element">
                  <div class="message" v-for="(vo,key) in leaveList" :key="`leave`+key">
                    <div class="big messageStyle">
                      <div class="messageleft">
                        <div class="bigImg">
                          <img :src="vo.head_url" alt="">
                        </div>
                      </div>
                      <div class="right">
                        <div class="nameTime">
                          <div class="name">{{vo.user_name}}</div>
                          <div class="time">{{vo.create_time}}</div>
                        </div>
                        <div class="wordCont">{{vo.content}}</div>
                      </div>
                    </div>
                    <div class="small">
                      <!-- 1 -->
                      <div
                        class="messageStyle smallMore"
                        v-for="(v,k) in vo.list"
                        :ref="'element'+key+'_'+k"
                        :key="`message`+k"
                      >
                        <div class="messageleft">
                          <div
                            class="blueLine"
                            v-show="k<vo.list.length -1"
                            :style="{height:v.height +'px'}"
                          ></div>
                          <div class="smallImg" @click="toUserInfo()">
                            <img :src="v.head_url" alt="">
                          </div>
                        </div>
                        <div class="right">
                          <div class="nameTime">
                            <div class="name">{{v.user_name}}</div>
                            <div class="time">{{v.create_time}}</div>
                          </div>
                          <div class="wordCont">{{v.content}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>{{str}}</div>
  </div>
</template>

<script>
  import Topheader from "../components/header"; //上传图片

  export default {
    name: "seeinterflow",
    components: {
      Topheader
    },
    data() {
      return {
        str: " ",
        tabActive: 1, //tab切换
        MsgHeight: "", //获取元素高度
        textareaWord: "", // textare文字
        textareaLength: "", // textare长度
        placeholder: "您要回复怎么样的事呢？",
        id: null,
        info: {
          dynamic: {
            imgList: []
          }
        },
        leaveList: []
      };
    },
    watch: {
      // 方法1
      $route(to, from) {
        //监听路由是否变化
        //获取文章数据
        this.id = this.$route.query.id; //
        this.getInfo();
      }
    },
    mounted() {
      document
        .querySelector("body")
        .setAttribute("style", "background-color:#fff");
      // 获取左边高度
      //let conH = this.$refs.monthPie.offsetHeight;
    },
    created() {
      this.id = this.$route.query.id;
      this.getInfo();
    },
    methods: {
      updated: function() {
        this.$nextTick(function() {
          // var div = document.getElementById("message_box");
          // console.log(div, "scrollHeight");
          // div.scrollTop = div.scrollHeight;
        });
      },
      //获取信息
      getInfo() {
        let _this = this;
        _this.common.request("api/dynamicLeave/info", { id: _this.id }, function(
          res
        ) {
          if (res.status == 200) {
            _this.info = res.data.info;
            _this.leaveList = res.data.leaveList;

            _this.placeholder =
              "您要回复怎么样的事呢？" +
              _this.info.user_name +
              "说：(" +
              _this.info.content +
              ")";

            _this.updated();

            //获取高度
            for (let i = 0; i < _this.leaveList.length; i++) {
              for (let j = 0; j < _this.leaveList[i].list.length; j++) {
                _this.$nextTick(() => {
                  let contHeight =
                    _this.$refs["element" + i + "_" + j][0].scrollHeight;
                  _this.leaveList[i].list[j].height = contHeight;
                  _this.str += " ";
                });
              }
            }
          }
        });
      },
      //回复数据
      onSubmit() {
        let _this = this;
        _this.common.request(
          "api/dynamicLeave/revert",
          { id: _this.info.id, content: _this.textareaWord },
          function(res) {
            if (res.status == 200) {
              _this.$message({
                message: res.message,
                type: "success",
                duration: 1500,
                center: true,
                onClose: function(res) {
                  _this.$router.go(-1);
                }
              });
            }
          },
          "post"
        );
      },
      //点击高光
      onHighlight() {
        let _this = this;
        let id = _this.info.dynamic.id;
        _this.common.request(
          "api/dynamic/highlight",
          { id: id },
          function(res) {
            if (res.status == 200) {
              _this.common.vMessage(res.message);
              _this.info.dynamic.highlight_num = res.data.highlight_num; //
              _this.info.dynamic.is_highlight = !_this.info.dynamic.is_highlight; //
            }
          },
          "post"
        );
      },
      //tab切换
      tab(num) {
        console.log(num);
        if (num == 1) {
          this.tabActive = 1;
        } else {
          this.tabActive = 2;
        }
      },

      //监听textares长度
      textareaWordL() {
        this.textareaLength = this.textareaWord.length;
      }
    }
  };
</script>

<style lang="less" scoped>
  @import "../assets/css/index.less";

  .seeinterflow {
    display: flex;
    justify-content: flex-start;
    margin-top: 17px;
    .left {
      width: 600px;
      margin-right: 24px;
      .word {
        color: #1c1c1c;
        font-size: 14px;
        line-height: 24px;
        .thteeLines;
      }
      .Img {
        .imgCut(600px, 600px);
        margin-bottom: 25px;
      }

      // Highlight
      .HeightLight.active {
        padding-top: 20px;
      }
      .HeightLight {
        border-bottom: 1px solid #dedede;
        padding-bottom: 20px;
        .flexEnd;
        .nameAll {
          .flexStart;
          span {
            width: 18px;
            height: 18px;
            margin-right: 11px;
            img {
              width: 18px;
              height: 18px;
            }
          }
          .name {
            color: #166593;
            font-size: 16px;
          }
        }
        .num {
          color: #7f7f7f;
          font-size: 22px;
          margin-left: 16px;
        }
      }

      // 头像
      .headerImgAll {
        border-bottom: 1px solid #dedede;
        padding: 18px 0;
        .flexStart;

        .nameS {
          margin-left: 15px;
          .nameWord {
            color: #7f7f7f;
            font-size: 18px;
            font-weight: bold;
          }
          .time {
            color: #7f7f7f;
            font-size: 14px;
            margin-top: 10px;
          }
        }
      }

      // 发布者
      .published {
        border-bottom: 1px solid #dedede;
        padding: 23px 0;
        .times {
          color: #575757;
          font-size: 16px;
          margin-bottom: 20px;
        }
        .Massege {
          .msgAll {
            .flexStart;
            color: #797979;
            font-size: 14px;
            padding-bottom: 13px;
            .tits {
              width: 56px;
              margin-right: 39px;
            }
          }
        }
      }
    }
    .right {
      width: 474px;
      //tit
      .tit {
        border-bottom: 1px solid #eeeeee;
        padding-bottom: 15px;
        .flexStart;
        .titWord {
          color: #000;
          font-size: 16px;
          margin-right: 48px;
          cursor: pointer;
          height: 32px;
        }
        .titWord.active {
          color: #166593;
        }
        .titWord:hover {
          height: 31px;
          border-bottom: 1px solid #166593;
        }
      }
      // textarea
      .Textarea {
        border-bottom: 1px solid #eee;

        .div1 {
          width: 474px;
          height: 60px;
          position: relative;
          overflow: hidden;
        }
        .div2 {
          overflow-x: hidden;
          overflow-y: scroll;
          position: absolute;
        }
        .div3 {
          width: 474px;
          height: 60px;
        }
        .textareaOne {
          color: #000;
          font-size: 12px;
          resize: none !important;
          width: 100%;
          padding: 3px 18px 3px 0;
          border: none;
          outline: none;
          max-height: 54px;
          margin: 10px 0;
        }
      }

      // post
      .postAll {
        .flexSBetween;
        padding: 16px 0;
        border-bottom: 1px solid #eee;
        .left {
          .num {
            color: #7f7f7f;
            font-size: 14px;
          }
        }
        .right {
          .flexEnd;
          .postBtn {
            color: #fff;
            font-size: 15px;
            width: 76px;
            height: 30px;
            line-height: 30px;
            background: #b0b0b0;
            text-align: center;
            .border-radius(15px);
            cursor: pointer;
          }
          .postBtn.active {
            background: #188ddf;
          }
          .postBtn:hover {
            background: #188ddf;
          }
        }
      }

      // talkMessage
      .talkMessage {
        margin-top: 28px;
        height: 600px;
        .div1 {
          width: 474px;
          height: 600px;
          position: relative;
          overflow: hidden;
        }
        .div2 {
          overflow-x: hidden;
          overflow-y: scroll;
          position: absolute;
        }
        .div3 {
          width: 474px;
          height: 600px;
        }
        .message {
          .big {
          }
          .messageStyle {
            display: flex;
            justify-content: flex-start;
            .messageleft {
              margin-right: 6px;
              position: relative;
              .bigImg {
                .border-radius(50%);
                .imgNoCut(46px;46px);
              }
              .blueLine {
                .positionALT(19px;0);

                width: 2px;
                background: #2287cd;
              }
            }

            .right {
              .nameTime {
                .flexStart;
                margin-bottom: 7px;
                .name {
                  color: #1d1d1d;
                  font-size: 16px;
                  margin-right: 13px;
                }
                .time {
                  color: #7f7f7f;
                  font-size: 14px;
                }
              }
              .wordCont {
                color: #000;
                font-size: 14px;
                margin-bottom: 20px;
              }
              .speak {
                color: #7f7f7f;
                font-size: 14px;
              }
            }
          }

          .small {
            margin-left: 52px;
            .smallImg {
              .border-radius(50%);
              .imgNoCut(38px;38px);
            }
          }

          // .smallMore {
          //   border-left: 1px solid #2287CD;
          // }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/view/huifu.vue